import { MODULE_NAME as ACCOUNTS_MODULE } from 'modules/accounts';
import { MODULE_NAME as AUDIENCE_INSIGHTS_MODULE } from 'modules/audience-insights/config/routes';
import { MODULE_NAME as AUDIENCES_MODULE } from 'modules/audiences/config/routes';
import { MODULE_NAME as BILLING_MODULE } from 'modules/billing-and-payments/config/routes';
import { MODULE_NAME as CREATIVE_LIBRARY_MODULE } from 'modules/creative-library/config/routes';
import { MODULE_NAME as LANDING_PAGES_MODULE } from 'modules/landing-pages/config/routes';
import { MODULE_NAME as PERFORMANCE_RULES_MODULE } from 'modules/performance-rules/config/routes';
import { MODULE_NAME as PUSH_API_MODULE } from 'modules/push-api/config/routes/module';
import { MODULE_NAME as SCHEDULED_REPORTS } from 'modules/scheduled-reports/config/routes';
import { MODULE_NAME as TRACKING_MODULE } from 'modules/tracking/config/routes';
import { CAMPAIGN_DIMENSION } from 'services/campaignDimension';
import { getModuleName } from 'services/url/urlParams';
import { isRealTimeReport } from '../../../config/isRealTimeReport';
import { ACCOUNT_LIST_REPORT_ID } from '../config/reports/account-list/accountListReportId';
import { CONVERSIONS_REPORT_ID } from '../config/reports/conversions/conversionsReportId';
import { CREATIVE_LIBRARY_REPORT_ID } from '../config/reports/creative-library/creativeLibraryReportId';
import { DAY_VIDEO_REPORT_ID } from '../config/reports/day-video/dayVideoReportId';
import { DAY_REPORT_ID } from '../config/reports/day/dayReportId';
import { DYNAMIC_REPORTS_REPORT_ID } from '../config/reports/dynamic-reports/dynamicReportsReportId';
import { LANDING_PAGES_REPORT_ID } from '../config/reports/landing-pages/landingPagesReportId';
import { PAYMENTS_REPORT_ID } from '../config/reports/payments/paymentsReportId';
import { PERFORMANCE_RULES_REPORT_ID } from '../config/reports/performance-rules/performanceRulesReportId';
import { PIXEL_BASED_REPORT_ID } from '../config/reports/pixel-based/pixelBasedReportId';
import { PUSH_API_REPORT_ID } from '../config/reports/push-api/pushApiReportId';
import { SEGMENT_CATEGORY_REPORT_ID } from '../config/reports/segment-category/segmentCategoryReportId';
import { TODAY_REPORT_ID } from '../config/reports/today/todayReportId';

const MODULE_REPORT_MAP = {
    [TRACKING_MODULE]: CONVERSIONS_REPORT_ID,
    [AUDIENCES_MODULE]: PIXEL_BASED_REPORT_ID,
    [AUDIENCE_INSIGHTS_MODULE]: SEGMENT_CATEGORY_REPORT_ID,
    [BILLING_MODULE]: PAYMENTS_REPORT_ID,
    [PERFORMANCE_RULES_MODULE]: PERFORMANCE_RULES_REPORT_ID,
    [SCHEDULED_REPORTS]: DYNAMIC_REPORTS_REPORT_ID,
    [PUSH_API_MODULE]: PUSH_API_REPORT_ID,
    [CREATIVE_LIBRARY_MODULE]: CREATIVE_LIBRARY_REPORT_ID,
    [LANDING_PAGES_MODULE]: LANDING_PAGES_REPORT_ID,
    [ACCOUNTS_MODULE]: ACCOUNT_LIST_REPORT_ID,
};

const DIMENSION_REPORT_MAP = {
    [CAMPAIGN_DIMENSION.SPONSORED]: DAY_REPORT_ID,
    [CAMPAIGN_DIMENSION.VIDEO]: DAY_VIDEO_REPORT_ID,
};

export const getDefaultReportId = (dimension = CAMPAIGN_DIMENSION.SPONSORED) => {
    const module = getModuleName();

    if (MODULE_REPORT_MAP[module]) {
        return MODULE_REPORT_MAP[module];
    }

    if (isRealTimeReport()) {
        return TODAY_REPORT_ID;
    }

    return DIMENSION_REPORT_MAP[dimension] || DAY_REPORT_ID;
};
